module.exports = __webpack_public_path__ + "static/img/DataServices.20fb172e.png";